<!-- [팝업] 타겟그룹 선택 -->
<template>
  <b-modal
    v-model="showTargetGroupSelect"
    cancel-variant="outline-secondary"
    centered
    ok-title="적용"
    cancel-title="취소"
    size="lg"
    title="타겟그룹 선택"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <b-row
      class="mt-25"
    >
      <b-col
        cols="12"
        md="10"
        class="d-flex align-items-center justify-content-center"
      >
        <b-form-input
          v-model="query.filterStr"
          class="el-def"
          placeholder="검색어를 입력하세요."
          @keyup.enter="refetchData()"
        />
      </b-col>
      <!-- Search -->
      <b-col
        cols="12"
        md="2"
        class="d-flex align-items-center justify-content-end"
      >
        <b-button
          variant="primary"
          class="btn-search"
          @click.prevent="refetchData()"
        >
          조회
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-table
        ref="refTargetGroupTable"
        primary-key="id"
        :items="fetchTargetGroups"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header
        selectable
        select-mode="single"
        class="position-relative"
        @row-selected="onRowSelectedTargetGroup"
        @row-dblclicked="onRowDblClickedTargetGroup"
      />
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-pagination
          v-model="currPage"
          :total-rows="totalRecords"
          limit="10"
          per-page="10"
          align="center"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import dayjs from 'dayjs'
import { ref, watch, onMounted } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { errorFormatter } from '@core/utils/filter'

export default {
  components: {
  },

  props: {
    showTargetGroupSelect: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    onMounted(() => {
      // fetchCodes()
    })

    const toast = useToast()

    // Query Data
    const query = ref({
      filterStr: null,
    })
    // Query Data End.

    const targetGroupData = ref(null)

    // Main Table Config
    const refTargetGroupTable = ref(null)
    // const sortBy = ref('modifyDate')
    // const sortBy = ref('liveInfoId')
    const sortBy = ref('id')
    const isSortDesc = ref(true)
    const currPage = ref(1)
    const totalRecords = ref(0)
    const targetCountFormatter = (value, key, item) => (`${value} 명 ${item.isExcludeCollection ? '제외' : '포함'}`)
    // const excludeFormatter = value => (value ? "exclude Set" : "Include Set")
    // const statusFormatter = value => codes.value.targetGroupStatus?.find(t => t.code === value).label
    const dateFormatter = value => dayjs(new Date(value)).format('YY-MM-DD')
    const tableColumns = [
      {
        key: 'id', label: 'ID', sortable: true, thStyle: { width: '8%' },
      },
      { key: 'targetGroupTitle', label: '이름', sortable: true },
      {
        key: 'collectedCount', label: '타겟인원수', sortable: true, formatter: targetCountFormatter, thStyle: { width: '25%' }, tdClass: 'text-right',
      },
      // {
      //   key: 'isExcludeCollection', label: '제외집합여부', sortable: true, formatter: excludeFormatter, thStyle: { width: '10%' },
      // },
      // {
      //   key: 'status', label: '그룹상태', sortable: true, formatter: statusFormatter, thStyle: { width: '10%' }, tdClass: 'text-center',
      // },
      {
        key: 'createDate', label: '등록일자', sortable: true, formatter: dateFormatter, thStyle: { width: '20%' }, tdClass: 'text-center',
      },
    ]
    const refetchData = () => {
      refTargetGroupTable.value.refresh()
    }
    watch([currPage], () => {
      refetchData()
    })
    const onRowSelectedTargetGroup = items => {
      const item = items[0]
      if (item) {
        targetGroupData.value = item
      }
    }
    const onRowDblClickedTargetGroup = item => {
      if (item) {
        targetGroupData.value = item
      }
      submit()
    }
    // Main Table Config End.

    const fetchTargetGroups = (ctx, callback) => {
      axios.post('/fa/target-group/quick-search', {
        search: {
          filterStr: query.value.filterStr,
        },
        sort: {
          predicate: sortBy.value,
          reverse: isSortDesc.value,
        },
        pagination: {
          number: currPage.value,
        },
      })
        .then(rs => {
          const { items, totalRecord } = rs.data
          callback(items)
          totalRecords.value = totalRecord
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: errorFormatter(error, '데이터 조회에 실패하였습니다.'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    const close = () => {
      emit('close', null)
    }

    const submit = () => {
      if (targetGroupData.value === null) {
        toast({
          component: ToastificationContent,
          props: {
            title: '타겟그룹을 선택하세요',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      emit('close', targetGroupData.value)
    }

    return {
      query,
      close,
      submit,
      refTargetGroupTable,
      sortBy,
      currPage,
      isSortDesc,
      totalRecords,
      tableColumns,
      refetchData,
      onRowSelectedTargetGroup,
      onRowDblClickedTargetGroup,
      fetchTargetGroups,
    }
  },
}
</script>
